import React, { useState } from "react";

import GridContainer from "@jumbo/components/GridContainer";
import { Grid } from "@material-ui/core";
import FormSettingsContainer from "./FormSettings";
import CurrFormContainer from "./FormContainer";

const FormBuilderContainer = () => {
  const [isSetting, setIsSetting] = useState(false);
  return (
    <>
      <GridContainer>
        <Grid item xs={12} md={5} style={{ minWidth: 0 }}>
          <FormSettingsContainer setIsSetting={setIsSetting} />
        </Grid>
        <Grid item xs={12} md={7} style={{ minWidth: 0 }}>
          <CurrFormContainer isSetting={isSetting} />
        </Grid>
      </GridContainer>
    </>
  );
};

export default FormBuilderContainer;
